//判断当前屏幕高度
var tableHeight = document.documentElement.clientHeight -180

export default tableHeight;

